function Ctrl($scope) {
  $scope.appId = function() {
    return '634444177';
  };

  $scope.appArgument = function() {
    return window.location.href;
  };
}

Ctrl.$inject = [
  '$scope'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/smartBanner/controller.js